import { IOnboardingStepDisplayProps } from "./OnboardingStepDisplay";

import tickCircle from "../../../assets/icons/tick-circle.svg";

export const View = (props: IOnboardingStepDisplayProps) => {
  const { step, stepsPerPage, totalSteps } = props;

  const CounterValueDisplay = () => {
    return (
      <>
        {Array.from({ length: totalSteps }, (v, k) => k + 1).map((v, k) => {
          const index = k + 1;
          const isActive = index === step;
          const isCompleted = index < step;
          const is_disabled = index > step;
          const isLast = index === totalSteps;
          const isFirst = index === 1;
          const isMiddle = !isFirst && !isLast;

          return (
            <div
              key={k}
              className={`flex-box flex-container flex-align-center flex-justify-center counter-value-display ${
                isActive ? "counter-value-display--active" : ""
              } ${isCompleted ? "counter-value-display--completed" : ""} ${
                is_disabled ? "counter-value-display--disabled" : ""
              }`}
            >
              {isLast ? null : <div className="step-active--indicator" />}

              <span
                className={`${isActive ? "step-active" : ""} ${
                  isCompleted ? "step-completed" : ""
                } ${
                  is_disabled ? "step-disabled" : ""
                } font-ctm--black onboarding-step`}
              >
                {isCompleted ? (
                  <img
                    src={tickCircle}
                    className="step-completed--icon"
                    alt="step completed icon"
                  />
                ) : (
                  index
                )}
              </span>

              <div className="flex-box flex-align-center flex-justify-center counter-linker" />
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className="flex-container flex-break--small onboarding-display--container">
      <div className={"flex-box flex-container onboarding-display--values"}>
        <CounterValueDisplay />
      </div>

      {stepsPerPage > 1 &&
        Array.from({ length: stepsPerPage - 1 }, (v, k) => k + 1).map(
          (v, k) => {
            return <div key={k} className="flex-box" />;
          }
        )}
    </div>
  );
};
